import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const BlockToolbar = styled.div<{ isVisible: boolean }>`
  position: absolute;
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  z-index: 1;
  right: ${theme.spacing.small};
  top: -${theme.spacing.large};
  background-color: ${theme.color.white};
  border-radius: ${theme.borderRadius.small};
  padding: ${theme.spacing.xxSmall};
  box-shadow:
    0px 6px 10px rgba(0, 0, 0, 0.14),
    0px 1px 18px rgba(0, 0, 0, 0.12),
    0px 3px 5px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
`;
